import { render, staticRenderFns } from "./ChainAddProjectModal.vue?vue&type=template&id=ca60a608"
import script from "./ChainAddProjectModal.vue?vue&type=script&lang=ts"
export * from "./ChainAddProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./ChainAddProjectModal.vue?vue&type=style&index=0&id=ca60a608&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports